
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsb6ddd25a5c4fd6288118ee10d64d0699en from './en.yaml'
            i18n.addResourceBundle('en', 'b6ddd25a5c4fd6288118ee10d64d0699', flattenObject(nsb6ddd25a5c4fd6288118ee10d64d0699en), true, true);
        
        export default 'b6ddd25a5c4fd6288118ee10d64d0699';
    